import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Snackbar,
  Grid,
  Paper,
  TableCell,
  TableRow,
  TableHead,
  Table,
  TableContainer,
  TableBody,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../../utils/api";
import style from "../../../../styles/brsr/general.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const ErrorText = ({ error, fieldLabel }) =>
  error ? (
    <Typography color="error" sx={{ fontSize: "12px", marginTop: "5px" }}>
      {fieldLabel ? `${fieldLabel}: ${error}` : error}
    </Typography>
  ) : null;

const CustomTableRow = ({
  label,
  fields,
  formData,
  handleInputChange,
  placeholder,
  errors,
  isOtherRow = false,
  dynamicLabel,
  handleDynamicLabelChange,
  disabled,
}) => (
  <TableRow sx={{ height: "20px" }}>
    <TableCell>
      {isOtherRow ? (
        <TextField
          name="others"
          disabled={disabled}
          // value={dynamicLabel}
          value={
            formData.other?.others !== undefined ? formData.other.others : ""
          }
          // onChange={(e) => handleDynamicLabelChange(e.target.value)}
          onChange={(e) => handleInputChange("other", "others", e.target.value)}
          size="small"
          placeholder="Others-Please Specify"
          InputProps={{ disableUnderline: true }}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            marginLeft: "-1rem",
          }}
          error={!!errors["other.others"]}
        />
      ) : (
        label
      )}
    </TableCell>
    {isOtherRow ? (
      <TableCell>
        <TextField
          name="percentageValue"
          value={
            formData.other?.percentageValue !== undefined
              ? formData.other.percentageValue
              : ""
          }
          disabled={disabled}
          onChange={(e) =>
            handleInputChange("other", "percentageValue", e.target.value)
          }
          size="small"
          placeholder="Enter %"
          InputProps={{ disableUnderline: true }}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
          }}
          error={!!errors["other.percentageValue"]}
        />
      </TableCell>
    ) : (
      fields.map((field) => (
        <TableCell key={field}>
          <TextField
            name={field}
            value={formData[field] !== undefined ? formData[field] : ""}
            disabled={disabled}
            onChange={(e) => handleInputChange(null, field, e.target.value)}
            size="small"
            placeholder={placeholder}
            InputProps={{ disableUnderline: true }}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": { border: "none" },
            }}
            error={!!errors[field]}
          />
        </TableCell>
      ))
    )}
  </TableRow>
);

const LeadershipIndicatorsForm = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const [modalupload, setModalUpload] = useState({
    businessProcessBeingModifiedDoc: false,
    humanRightsDueDiligenceDoc: false,
    accessibilityToDifferentlyAbledDoc: false,
    valueChainPartnerAssessmentsDoc: false,
    correctiveActionTakenUnderwayDoc: false,
    grievanceRedressalMechanismsDoc: false,
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [progress, setUploadProgress] = useState([]);
  const [open, setOpen] = useState(false);
  const [formData1, setFormData1] = useState({});
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [formData, setFormData] = useState({
    businessProcessBeingModified: "",
    humanRightsDueDiligence: "",
    accessibilityToDifferentlyAbled: "",
    correctiveActionTakenUnderway: "",
    grievanceRedressalMechanisms: "",
    sexualHarassment: "",
    discrimination: "",
    childLabor: "",
    forcedLabor: "",
    wages: "",
    other: { others: "", percentageValue: "" },
  });

  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [dynamicLabel, setDynamicLabel] = useState("");

  const handleChange = (field, value) => {
    setErrors((prev) => ({
      ...prev,
      [field]: value.trim() ? "" : prev[field],
    }));
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleDynamicLabelChange = (label) => {
    setDynamicLabel(label);
  };

  const type = "SectionC";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `${api}/brsr/get?subType=principle5&type=${type}&id=${id}`
        );
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);

        if (
          response &&
          response?.data &&
          response?.data?.data?.BRSRSectionC &&
          response?.data?.data?.BRSRSectionC?.principle5?.leadershipIndicator
        ) {
          const leadershipIndicator =
            response?.data?.data?.BRSRSectionC?.principle5?.leadershipIndicator;
          setFormData1({
            businessProcessBeingModifiedDoc:
              leadershipIndicator?.businessProcessBeingModifiedDoc ?? [],
            humanRightsDueDiligenceDoc:
              leadershipIndicator?.humanRightsDueDiligenceDoc ?? [],
            accessibilityToDifferentlyAbledDoc:
              leadershipIndicator?.accessibilityToDifferentlyAbledDoc ?? [],
            valueChainPartnerAssessmentsDoc:
              leadershipIndicator?.valueChainPartnerAssessmentsDoc ?? [],
            correctiveActionTakenUnderwayDoc:
              leadershipIndicator?.correctiveActionTakenUnderwayDoc ?? [],
            grievanceRedressalMechanismsDoc:
              leadershipIndicator?.grievanceRedressalMechanismsDoc ?? [],
          });
          setFormData({
            businessProcessBeingModified:
              leadershipIndicator.businessProcessBeingModified ?? "",
            humanRightsDueDiligence:
              leadershipIndicator.humanRightsDueDiligence ?? "",
            accessibilityToDifferentlyAbled:
              leadershipIndicator.accessibilityToDifferentlyAbled ?? "",
            correctiveActionTakenUnderway:
              leadershipIndicator.correctiveActionTakenUnderway ?? "",
            sexualHarassment:
              leadershipIndicator?.sexualHarassment !== undefined
                ? leadershipIndicator?.sexualHarassment
                : "",
            discrimination:
              leadershipIndicator?.discrimination !== undefined
                ? leadershipIndicator?.discrimination
                : "",
            childLabor:
              leadershipIndicator?.childLabor !== undefined
                ? leadershipIndicator?.childLabor
                : "",
            forcedLabor:
              leadershipIndicator?.forcedLabor !== undefined
                ? leadershipIndicator?.forcedLabor
                : "",
            wages:
              leadershipIndicator?.wages !== undefined
                ? leadershipIndicator?.wages
                : "",
            grievanceRedressalMechanisms:
              leadershipIndicator?.grievanceRedressalMechanisms ?? "",
            other: {
              others:
                leadershipIndicator?.other?.others !== undefined
                  ? leadershipIndicator?.other.others
                  : "",
              percentageValue:
                leadershipIndicator?.other?.percentageValue !== undefined
                  ? leadershipIndicator?.other.percentageValue
                  : "",
            },
          });
        } else {
          console.error("Leadership Indicator data is not available.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [id, type]);

  // const handleInputChange = (parentField, field, value) => {
  //   setFormData((prevData) => {
  //     if (parentField) {
  //       return {
  //         ...prevData,
  //         [parentField]: {
  //           ...prevData[parentField],
  //           [field]: value.trim(), // Trim to avoid unnecessary spaces
  //         },
  //       };
  //     }
  //     return {
  //       ...prevData,
  //       [field]: value.trim(),
  //     };
  //   });

  //   setErrors((prevErrors) => {
  //     const newErrors = { ...prevErrors };
  //     if (value.trim()) {
  //       delete newErrors[field];
  //     } else {
  //       newErrors[field] = "This field is required.";
  //     }
  //     return newErrors;
  //   });
  // };

  const handleInputChange = (parentField, field, value) => {
    if (field !== "others" && (!/^\d*\.?\d*$/.test(value) || value > 100))
      return;
    setFormData((prevData) => {
      if (parentField) {
        return {
          ...prevData,
          [parentField]: {
            ...prevData[parentField],
            [field]: value.trim(), // Trim to avoid unnecessary spaces
          },
        };
      }
      return {
        ...prevData,
        [field]: value.trim(),
      };
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (parentField === "other") {
        if (field === "others" && value.trim()) {
          delete newErrors["other.others"];
        }
        if (field === "percentageValue") {
          const percentageValue = Number(value);
          if (
            !isNaN(percentageValue) &&
            percentageValue >= 0 &&
            percentageValue <= 100
          ) {
            delete newErrors["other.percentageValue"];
          }
        }
      } else {
        if (value.trim()) {
          delete newErrors[field];
        } else {
          newErrors[field] = "This field is required.";
        }
      }

      return newErrors;
    });
  };

  const validateForm = () => {
    const newErrors = {};

    Object.keys(formData).forEach((key) => {
      const value = formData[key];

      if (
        [
          "sexualHarassment",
          "discrimination",
          "childLabor",
          "forcedLabor",
          "wages",
        ].includes(key)
      ) {
        const percentageValue = Number(value);

        if (
          isNaN(percentageValue) ||
          percentageValue < 0 ||
          percentageValue > 100
        ) {
          newErrors[key] = "Please enter a valid percentage between 0 and 100.";
        }
      }

      if (key === "other") {
        if (value?.others?.trim() || value?.percentageValue) {
          if (!value?.others?.trim()) {
            newErrors["other.others"] =
              "This field is required when percentage is entered.";
          }
          if (value?.percentageValue == null || value?.percentageValue === "") {
            newErrors["other.percentageValue"] =
              "This field is required when 'Other-specify' is entered.";
          } else if (isNaN(value.percentageValue)) {
            newErrors["other.percentageValue"] = "Please enter a valid number.";
          } else if (value.percentageValue < 0 || value.percentageValue > 100) {
            newErrors["other.percentageValue"] =
              "Percentage must be between 0 and 100.";
          }
        }
      } else if (typeof value === "string" && !value.trim()) {
        newErrors[key] = "This field is required.";
      } else if (
        typeof value !== "string" &&
        value?.others?.trim &&
        !value.others.trim()
      ) {
        newErrors[key] = "This field is required.";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // if (!validateForm()) return;
      const payload = {
        leadershipIndicator: {
          ...formData,
          ...formData1,
        },

        leadershipIndicatorSubmitted: true,
        type: "SectionC",
        subType: "principle5",
      };
      try {
        const response = await put(`${api}/brsr/update?id=${id}`, payload);
        setSnackOpen({
          open: true,
          message: "Data saved successfully!",
          severity: "success",
        });
        navigate(`/brsr/section-c/principle6/${id}`);
        if (onSave) onSave(response.data);
      } catch (error) {
        setSnackOpen({
          open: true,
          message: "Failed to save data. Please try again.",
          severity: "error",
        });
      }
    } else navigate(`/brsr/section-c/principle6/${id}`);
  };

  const renderTextField = (label, fieldName) => (
    <Box mb={4}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          textIndent: "-1rem",
          paddingLeft: "0.9rem",
          mt: 2,
        }}
        gutterBottom
      >
        {label}
      </Typography>
      <TextField
        fullWidth
        multiline
        disabled={disabled}
        rows={3}
        placeholder="Type Here"
        value={formData[fieldName]}
        onChange={(e) => handleChange(fieldName, e.target.value)}
        error={!!errors[fieldName]}
        sx={{ marginLeft: "0.9rem", width: "99%" }}
        helperText={
          <Typography
            variant="body2"
            color="error"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
              marginLeft: "-10px",
            }}
          >
            {errors[fieldName]}
          </Typography>
        }
      />
    </Box>
  );

  return (
    <Box>
      <p className={style.subHeading}>II. LEADERSHIP INDICATOR</p>

      {renderTextField(
        "1. Details of a business process being modified / introduced as a result of addressing human rights grievances / complaints.",
        "businessProcessBeingModified"
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "businessProcessBeingModifiedDoc",
          ml: 2,
          mt: "-1.5rem",
          removeUpload,
        }}
      />

      {renderTextField(
        "2. Details of the scope and coverage of any Human rights due-diligence conducted.",
        "humanRightsDueDiligence"
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "humanRightsDueDiligenceDoc",
          ml: 2,
          mt: "-1.5rem",
          removeUpload,
        }}
      />

      {renderTextField(
        "3. Is the premise / office of the entity accessible to differently abled visitors, as per the requirements of the Rights of Persons with Disabilities Act, 2016?",
        "accessibilityToDifferentlyAbled"
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "accessibilityToDifferentlyAbledDoc",
          ml: 2,
          mt: "-1.5rem",
          removeUpload,
        }}
      />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              textIndent: "-1rem",
              paddingLeft: "0.9rem",
              mt: 2,
            }}
            gutterBottom
          >
            4. Details on assessment of value chain partners:
          </Typography>
          <TableContainer
            component={Paper}
            sx={{
              mb: 2,
              borderRadius: "10px",
              width: "99%",
              marginLeft: "0.9rem",
            }}
          >
            <Table
              sx={{
                "& .MuiTableCell-root": {
                  borderRight: "1px solid #e0e0e0",
                  padding: "0px 16px",
                },
                tableLayout: "fixed",
                width: "100%",
              }}
            >
              <TableHead>
                <TableRow sx={{ bgcolor: "#1C486B", height: "40px" }}>
                  <TableCell
                    sx={{
                      color: "white",
                      borderBottom: "1px solid white",
                      width: "12%",
                    }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      color: "white",
                      borderBottom: "1px solid white",
                      width: "22%",
                    }}
                  >
                    % of value chain partners (by value of business done with
                    such partners) that were assessed
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <CustomTableRow
                  disabled={disabled}
                  label="Sexual Harassment"
                  fields={["sexualHarassment"]}
                  placeholder="Enter %"
                  formData={formData}
                  handleInputChange={handleInputChange}
                  errors={errors}
                />
                <CustomTableRow
                  disabled={disabled}
                  label="Discrimination at workplace"
                  fields={["discrimination"]}
                  placeholder="Enter %"
                  formData={formData}
                  handleInputChange={handleInputChange}
                  errors={errors}
                />
                <CustomTableRow
                  disabled={disabled}
                  label="Child Labor"
                  fields={["childLabor"]}
                  placeholder="Enter %"
                  formData={formData}
                  handleInputChange={handleInputChange}
                  errors={errors}
                />
                <CustomTableRow
                  disabled={disabled}
                  label="Forced Labor / Involuntary Labor"
                  fields={["forcedLabor"]}
                  placeholder="Enter %"
                  formData={formData}
                  handleInputChange={handleInputChange}
                  errors={errors}
                />
                <CustomTableRow
                  disabled={disabled}
                  label="Wages"
                  fields={["wages"]}
                  placeholder="Enter %"
                  formData={formData}
                  handleInputChange={handleInputChange}
                  errors={errors}
                />

                <CustomTableRow
                  disabled={disabled}
                  label="Other - Please Specify"
                  isOtherRow={true}
                  fields={[]}
                  formData={formData}
                  handleInputChange={handleInputChange}
                  placeholder="Enter %"
                  errors={errors}
                  dynamicLabel={dynamicLabel}
                  handleDynamicLabelChange={handleDynamicLabelChange}
                />
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ margin: "-10px 0px 10px 0px" }}>
            {Object.entries(errors)
              .filter(([field]) =>
                [
                  "sexualHarassment",
                  "discrimination",
                  "childLabor",
                  "forcedLabor",
                  "wages",
                  "other.others",
                  "other.percentageValue",
                ].includes(field)
              )
              .map(([field, error]) => (
                <span
                  key={field}
                  style={{
                    fontSize: "12px",
                    color: "#d34040",
                    marginTop: "-1rem",
                    marginRight: "0.4rem",
                  }}
                >
                  {`${field.replace(/([A-Z])/g, " $1")}: ${error}`}
                </span>
              ))}
          </Box>
        </Grid>
      </Grid>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "valueChainPartnerAssessmentsDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
      <Box sx={{ mt: 2 }}>
        {renderTextField(
          "5. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from the assessments at Question 4 above.",
          "correctiveActionTakenUnderway"
        )}
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "correctiveActionTakenUnderwayDoc",
          ml: 2,
          mt: "-1.5rem",
          removeUpload,
        }}
      />
      <Box sx={{ mt: 2 }}>
        {renderTextField(
          "6. Describe the internal mechanisms in place to redress grievances related to human rights issues.",
          "grievanceRedressalMechanisms"
        )}
      </Box>
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData: formData1,
          setFormData: setFormData1,
          errors,
          setErrors,
          open,
          setOpen,
          Uploadkey: "grievanceRedressalMechanismsDoc",
          ml: 2,
          mt: "-1.5rem",
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "0.9rem", width: "99%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
                onClick={handleSubmit}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}

      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setSnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default LeadershipIndicatorsForm;
